import { Banner, spacing, Text } from "@minuthq/meatball-ui-react"

import { useDeleteParadiseQuote } from "src/data/paradise/paradiseQuotes/paradiseQuoteQueries"
import ConfirmDialog from "src/ui/Dialog/ConfirmDialog"

export function ParadiseDeleteQuoteDialog({
  open,
  onClose,
  quoteId,
}: {
  open: boolean
  onClose: () => void
  quoteId: string
}) {
  const deleteParadiseQuote = useDeleteParadiseQuote()

  function deleteQuote() {
    deleteParadiseQuote.mutate(quoteId, {
      onSuccess: () => {
        onClose()
      },
    })
  }
  return (
    <ConfirmDialog
      title="Delete quote"
      confirmLabel="Delete"
      onConfirm={deleteQuote}
      confirmButtonProps={{
        color: "destructive",
      }}
      open={open}
      onClose={onClose}
      width="medium"
      loading={deleteParadiseQuote.isLoading}
    >
      <Text variant="subtitle" marginBottom={spacing.M}>
        Are you sure you want to delete this quote?
      </Text>
      <Banner type="warning" fullWidth>
        Customers will no longer be able to purchase this quote
      </Banner>
    </ConfirmDialog>
  )
}
